import { FC } from "preact/compat";
import { ButtonProps } from "./interfaces";

const Button: FC<ButtonProps> = ({ action, content }) => (
    <button type="button" data-d-action={action}>
        {content ?? "-"}
    </button>
);

export default Button;
